module.exports = "/_next/static/images/36d39b03b7a4e51fb4be8ad9bc1141fa-piecito-desktop.jpg";